import React from 'react';
import { Control, Controller, FieldPath, FieldValues } from 'react-hook-form';
import { ErrorTooltip, StackedTextCell } from '@retail/components';
import { StyledTextField } from '@retail/my-assortment/components';
import { Box, Typography } from '@mui/material';
import { useCampaignTFunction } from '@retail/campaign/i18n';

interface Props<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
> {
  error?: string;
  fieldName: TName;
  control: Control<TFieldValues>;
  incVat: boolean;
  disabled?: boolean;
}

export const PriceInput = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>({
  control,
  error,
  fieldName,
  incVat,
  disabled,
}: Props<TFieldValues, TName>) => {
  const t = useCampaignTFunction();
  return (
    <Box display="flex" alignItems="center">
      <Controller
        name={fieldName}
        disabled={disabled}
        control={control}
        render={({ field }) => (
          <StackedTextCell
            gap="small"
            topLine={
              <ErrorTooltip title={error} arrow>
                <StyledTextField
                  {...field}
                  value={disabled ? '' : field.value}
                  size="small"
                  width={115}
                  error={!!error}
                />
              </ErrorTooltip>
            }
            bottomLine={
              <Typography fontStyle="italic" variant="body2" sx={{ pl: 1 }}>
                {incVat ? t('campaign.columns.incVat') : t('campaign.columns.exVat')}
              </Typography>
            }
          />
        )}
      />
    </Box>
  );
};
